module.exports = __webpack_public_path__ + "img/soldier-salutes.4e328728.png";